module.exports = __webpack_public_path__ + "img/photo-24.0db0cc0e.jpg";